import { toHeaderSegment } from '../utils';
export const getSearchUrl = (locationSegment, customerType) => {
    let searchSegment;
    const headerSegment = toHeaderSegment(locationSegment, !customerType);
    if (headerSegment) {
        searchSegment = headerSegment === 'business' ? 'ari' : 'era';
    }
    if (customerType && !headerSegment) {
        searchSegment = customerType === 'B2B' ? 'ari' : 'era';
    }
    return `/${searchSegment || 'era'}/otsing`;
};
export const headerSearch = (rootStore) => {
    var _a, _b;
    const { translate, translations } = rootStore.translationsStore;
    const { value, searchSuggestions, handleChange, handleSubmit, handleSuggestionClick, dealerSearchSuggestions, handleDealerSearchSuggestionClick, loadDealerSearchSuggestions } = rootStore.searchStore;
    const { isEmbedded } = rootStore.propStateStore;
    if (!translations) {
        return undefined;
    }
    let dealerInitialSearchSuggestions = [];
    if (rootStore.ssoStore.isDealer && ((_a = dealerSearchSuggestions.items) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        dealerInitialSearchSuggestions = [
            {
                label: dealerSearchSuggestions.label,
                items: dealerSearchSuggestions.items.map((item) => ({
                    label: item.title,
                    url: item.url
                }))
            }
        ];
    }
    let autoCompleteSuggestions = [];
    if (searchSuggestions) {
        autoCompleteSuggestions = searchSuggestions.map((suggestion) => {
            return { ...suggestion, items: suggestion.items };
        });
    }
    const showDealerSuggestions = rootStore.ssoStore.isDealer && ((_b = rootStore.searchStore.value) === null || _b === void 0 ? void 0 : _b.length) < 3;
    return {
        id: 'header-search-bar',
        label: translate('header.search.placeholder'),
        items: showDealerSuggestions ? dealerInitialSearchSuggestions : autoCompleteSuggestions,
        value,
        placeholder: translate('header.search.placeholder'),
        input: {
            name: 'query',
            autoComplete: 'off',
            maxLength: 256
        },
        onSubmit: handleSubmit,
        onSelect: showDealerSuggestions ? handleDealerSearchSuggestionClick : handleSuggestionClick,
        onChange: handleChange,
        detailedViewButton: {
            text: translate('header.search.details'),
            onClick: handleSubmit
        },
        portalContainer: isEmbedded ? document.querySelector('#telia-header') : null,
        showSuggestionsOnFocus: showDealerSuggestions,
        onFocus: rootStore.ssoStore.isDealer && loadDealerSearchSuggestions
    };
};
export default headerSearch;
//# sourceMappingURL=HeaderSearch.js.map